import { Tabs, Accordion, Mobile, TRANSITION_END } from './core'
import Header from './modules/header'
import './plugins/animate-waves'
import './plugins/news-carousel'
import './plugins/ornament'
import './plugins/scroll-to-anchor'
import './plugins/text-bg-color'
import './plugins/heading-full-width'
import './plugins/thermometer'
import './plugins/read-more'
import './plugins/contact-form'
import './plugins/parallax'

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
  }

  /* Header */
  Header.init()

  /* Tabs */
  Tabs.init()

  /* Accordions */
  Accordion.init()

  /* Forms */
  $('.contact-form').each(function() {
    $(this).ContactForm()
  })

  /* Répertoires d'organismes - Scroll to anchor */
  $('.js-dive').each(function() {
    $(this).scrollToContent();
  })

  $('.submenu-row__links__item a, a.btn-anchor').each(function() {
    $(this).scrollToAnchor();
  })

  $('.heading-full-width').each(function() {
    $(this).headingFullWidth();
  })

  /* make videos look like images */
  $('.video-loop').each(function() {
    let self = $(this)
    let video = $(this).find('video')
    if (video.data('loaded')) {
      setTimeout(function() {
        picture(video.get(0))
        video.get(0).play()
      }, 60)
    } else {
      video.on('canplaythrough', function() {
        picture(video.get(0))
        video.get(0).play()
      })
    }
  })

  $('.bg-placement--half-right .carousel--style--new, .bg-placement--half-left .carousel--style--new').each(function() {
    $(this).NewsCarousel();
  })

  $('span[class*=text-bg], span.stat-prefix-suffix').each(function() {
    $(this).TextBgColor();
  })

  $('.col.white-bg').each(function() {
    $(this).closest('.page-section').addClass('white-bg-wrapper');
  })

  $('.page-section--wave-animated').each(function() {
    $(this).AnimateWaves();
  })

  $('.ornament-row').each(function( index ) {
    $(this).ornamentSection();
  });

  $('.btn-read-more').each(function( index ) {
    $(this).readMore();
  });

  $('.thermometer').each(function() {
    $(this).thermometer();
  })

  /* Fade-in elements */
  $('.fade-in, .slide-in').each(function() {
    $(this).FadeIn()
  })

  /* Fade-in elements */
  $('.gallery-row .desktop-only .gallery-row__item').each(function() {
    $(this).Parallax()
  })
})
